import { Routes, Route, Navigate } from 'react-router-dom';
import { BackofficeProvider } from '@contexts/BackofficeContext';
import { useBackoffice } from '@contexts/useBackoffice';
import BackofficeLayout from '@components/Backoffice/BackofficeLayout';
import BackofficePasswordGate from '../pages/Backoffice/BackofficePasswordGate';
import BackofficeOrganizations from '../pages/Backoffice/BackofficeOrganizations';
import BackofficeOrgDetail from '../pages/Backoffice/BackofficeOrgDetail';
import BackofficeUsers from '../pages/Backoffice/BackofficeUsers';
import BackofficeUserDetail from '../pages/Backoffice/BackofficeUserDetail';
import BackofficeBilling from '../pages/Backoffice/BackofficeBilling';
import BackofficeMemory from '../pages/Backoffice/BackofficeMemory';

const BASE = '/backoffice-admin';

function BackofficeGate() {
  const { isVerified } = useBackoffice();

  if (!isVerified) {
    return <BackofficePasswordGate />;
  }

  return (
    <BackofficeLayout>
      <Routes>
        <Route path={`${BASE}/organizations`} element={<BackofficeOrganizations />} />
        <Route path={`${BASE}/organizations/:orgId`} element={<BackofficeOrgDetail />} />
        <Route path={`${BASE}/users`} element={<BackofficeUsers />} />
        <Route path={`${BASE}/users/:userId`} element={<BackofficeUserDetail />} />
        <Route path={`${BASE}/billing`} element={<BackofficeBilling />} />
        <Route path={`${BASE}/memory`} element={<BackofficeMemory />} />
        <Route path={BASE} element={<Navigate to={`${BASE}/organizations`} replace />} />
        <Route path="*" element={<Navigate to={`${BASE}/organizations`} replace />} />
      </Routes>
    </BackofficeLayout>
  );
}

const BackofficeRoutes: React.FC = () => {
  return (
    <BackofficeProvider>
      <BackofficeGate />
    </BackofficeProvider>
  );
};

export default BackofficeRoutes;
